<template>
  <div class="cz-w980 cz-c clearfix cz-box02">
    <h1 class="cz-tit02 cz-tc  cz-c">{{ title }}支付</h1>
    <div class="cz-box03 cz-fl">
        <p class="cz-box04"><span class="cz-txt06">￥</span> <span class="cz-txt05">{{ payInfo.money }}</span></p>
        <p class="cz-box04">创建时间：{{ time }}</p>
        <p class="cz-box04">商户名称：成都市艺苑网络科技有限公司</p>
        <!-- <P class="cz-box04">扫描支付成功后，可在疯播APP查询充值结果！</P> -->
    </div>
    <div class="cz-box05 cz-fl">
        <div class="cz-box06 clearfix">
            <!-- <input id="text" type="hidden" value="<?php echo $url;?>" style="width:80%" /><br /> -->
            <div id="qrcode" class="cz-img02">
                <img v-if="payInfo.type == 'zfb'" src="@/assets/images/zfbCode.jpg" alt="" style="width: 200px; height: 200px">
                <img v-if="payInfo.type == 'wechat'" src="@/assets/images/wechatCode.jpg" alt="" style="width: 200px; height: 200px">
            </div>
            <p class="cz-txt07">请 使用 {{ title }} 扫描</br> 二维码以完成支付</p>
        </div>
    </div>

</div>
</template>

<script>
import '@/style/qrcode.css'
export default {
  name: 'PaySucc',
  computed: {
    payInfo () {
      return this.$store.state.payInfo.info
    }
  },
  data() {
    return {
      time: '',
      title: '',
      pid: ''
    }
  },
  created() {
    let time = new Date();
    let month = (time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1);
    let day = time.getDate() < 10 ? ('0' + time.getDate()) : time.getDate();
    let hours = time.getHours() < 10 ? ('0' + time.getHours()) : time.getHours();
    let minutes = time.getMinutes() < 10 ? ('0' + time.getMinutes()) : time.getMinutes();
    let seconds = time.getSeconds() < 10 ? ('0' + time.getSeconds()) : time.getSeconds();
    this.time = time.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    if (this.payInfo.type == 'zfb') {
        this.title = '支付宝'
    } else {
        this.title = '微信'
    }
  }
}
</script>
